import { useLang } from "@/lib/i18n";
import { eur } from "@/lib/api";

export const VAT_RATE = 0.21;
export const SHIPPING = 18;
const r2 = (n) => Math.round(n * 100) / 100;

export const calcTotals = (net, cod = false, ship = SHIPPING) => {
  const vat = r2(net * VAT_RATE);
  const total = r2(net + vat + ship);
  const final = cod ? Math.ceil(total / 5) * 5 : total;
  return { net, vat, shipping: r2(ship + final - total), total: final };
};

export const ExVat = ({ className = "" }) => {
  const { t } = useLang();
  return <span className={`text-[10px] font-mono-x uppercase tracking-wider text-slate-500 ml-1.5 whitespace-nowrap ${className}`}>{t("ex_vat")}</span>;
};

export const NetPrice = ({ value, old, className = "", testid }) => (
  <span className="inline-flex flex-col">
    {old > value && <span data-testid={testid && `${testid}-old`} className="text-sm font-mono-x text-slate-500 line-through">{eur(old)}</span>}
    <span className="inline-flex items-baseline flex-wrap">
      <span data-testid={testid} className={`${className} ${old > value ? "!text-red-400" : ""}`}>{eur(value)}</span><ExVat />
    </span>
  </span>
);

const Row = ({ label, value, testid }) => (
  <div className="flex justify-between text-slate-400"><span>{label}</span><span data-testid={testid} className="font-mono-x">{value}</span></div>
);

export const Totals = ({ net, vat, total, shipping, testid = "totals", big = "text-3xl" }) => {
  const { t } = useLang();
  const v = vat ?? r2(net * VAT_RATE);
  const g = total ?? r2(net + v + (shipping || 0));
  return (
    <div className="space-y-2 text-sm" data-testid={testid}>
      <Row label={t("subtotal_net")} value={eur(net)} testid={`${testid}-net`} />
      <Row label={t("vat_line")} value={eur(v)} testid={`${testid}-vat`} />
      {shipping != null && <Row label={t("shipping_vat")} value={eur(shipping)} testid={`${testid}-shipping`} />}
      <div className="flex justify-between items-end pt-1">
        <span className="uppercase tracking-widest text-slate-400">{t("total_gross")}</span>
        <span data-testid={`${testid}-gross`} className={`font-display font-black ${big} text-orange-500`}>{eur(g)}</span>
      </div>
    </div>
  );
};
